var map = {
	"./SpinSalonComunal_001.webp": 5846,
	"./SpinSalonComunal_002.webp": 4904,
	"./SpinSalonComunal_003.webp": 586,
	"./SpinSalonComunal_004.webp": 3281,
	"./SpinSalonComunal_005.webp": 3658,
	"./SpinSalonComunal_006.webp": 2381,
	"./SpinSalonComunal_007.webp": 9925,
	"./SpinSalonComunal_008.webp": 8285,
	"./SpinSalonComunal_009.webp": 564,
	"./SpinSalonComunal_010.webp": 7157,
	"./SpinSalonComunal_011.webp": 4183,
	"./SpinSalonComunal_012.webp": 9122,
	"./SpinSalonComunal_013.webp": 670,
	"./SpinSalonComunal_014.webp": 9279,
	"./SpinSalonComunal_015.webp": 7767,
	"./SpinSalonComunal_016.webp": 2335,
	"./SpinSalonComunal_017.webp": 6102,
	"./SpinSalonComunal_018.webp": 7342,
	"./SpinSalonComunal_019.webp": 1655,
	"./SpinSalonComunal_020.webp": 5115,
	"./SpinSalonComunal_021.webp": 3612,
	"./SpinSalonComunal_022.webp": 9060,
	"./SpinSalonComunal_023.webp": 1746,
	"./SpinSalonComunal_024.webp": 5082,
	"./SpinSalonComunal_025.webp": 6263,
	"./SpinSalonComunal_026.webp": 5830,
	"./SpinSalonComunal_027.webp": 7384,
	"./SpinSalonComunal_028.webp": 5781,
	"./SpinSalonComunal_029.webp": 2556,
	"./SpinSalonComunal_030.webp": 6373,
	"./SpinSalonComunal_031.webp": 7721,
	"./SpinSalonComunal_032.webp": 1274,
	"./SpinSalonComunal_033.webp": 8,
	"./SpinSalonComunal_034.webp": 2041,
	"./SpinSalonComunal_035.webp": 4720,
	"./SpinSalonComunal_036.webp": 1976
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2865;